import { z } from 'zod';

/** A ranked provider for a request, from match_providers_for_request. */
export interface CandidateProvider {
  readonly providerId: string;
  readonly fullName: string;
  readonly city: string | null;
  readonly yearsExperience: number | null;
  readonly qualifications: string | null;
  readonly verified: boolean;
  readonly ratingAvg: number;
  readonly ratingCount: number;
  readonly reliabilityScore: number;
  readonly isCertified: boolean;
  readonly distanceKm: number | null;
  readonly availabilityScore: number;
  readonly score: number;
  readonly hasApplied: boolean;
}

const rowSchema = z.object({
  provider_id: z.string(),
  full_name: z.string(),
  city: z.string().nullable(),
  years_experience: z.number().nullable(),
  qualifications: z.string().nullable(),
  verified: z.boolean(),
  rating_avg: z.number(),
  rating_count: z.number(),
  reliability_score: z.number(),
  is_certified: z.boolean(),
  distance_km: z.number().nullable(),
  availability_score: z.number(),
  score: z.number(),
  has_applied: z.boolean(),
});

export function mapCandidate(row: unknown): CandidateProvider {
  const r = rowSchema.parse(row);
  return {
    providerId: r.provider_id,
    fullName: r.full_name,
    city: r.city,
    yearsExperience: r.years_experience,
    qualifications: r.qualifications,
    verified: r.verified,
    ratingAvg: r.rating_avg,
    ratingCount: r.rating_count,
    reliabilityScore: r.reliability_score,
    isCertified: r.is_certified,
    distanceKm: r.distance_km,
    availabilityScore: r.availability_score,
    score: r.score,
    hasApplied: r.has_applied,
  };
}
